export function FacebookIcon({ size = 24 }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6875 12C21.6875 6.64844 17.3516 2.3125 12 2.3125C6.64844 2.3125 2.3125 6.64844 2.3125 12C2.3125 16.8352 5.85508 20.843 10.4863 21.5703V14.8004H8.02539V12H10.4863V9.86562C10.4863 7.43789 11.9316 6.09687 14.1453 6.09687C15.2055 6.09687 16.3141 6.28594 16.3141 6.28594V8.66875H15.0922C13.8891 8.66875 13.5137 9.41562 13.5137 10.1816V12H16.2004L15.7707 14.8004H13.5137V21.5703C18.1449 20.843 21.6875 16.8352 21.6875 12Z"
        fill="white"
      />
    </svg>
  );
}

export function GoogleIcon({ size = 24 }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5834 12.6649C21.5834 18.0533 17.8934 21.8881 12.444 21.8881C7.21935 21.8881 3 17.6687 3 12.444C3 7.21935 7.21935 3 12.444 3C14.9878 3 17.128 3.93298 18.7769 5.47144L16.2064 7.94288C12.8439 4.6984 6.59102 7.13557 6.59102 12.444C6.59102 15.738 9.2224 18.4075 12.444 18.4075C16.1836 18.4075 17.5849 15.7266 17.8058 14.3366H12.444V11.0884H21.4349C21.5225 11.572 21.5834 12.0366 21.5834 12.6649Z"
        fill="white"
      />
    </svg>
  );
}

export function AppleIcon({ size = 24 }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1149 16.8036C19.8097 17.5088 19.4484 18.1578 19.0298 18.7546C18.4592 19.5681 17.9921 20.1311 17.632 20.4438C17.0739 20.9571 16.476 21.22 15.8356 21.2349C15.3759 21.2349 14.8216 21.1041 14.1762 20.8388C13.5288 20.5746 12.9338 20.4438 12.3898 20.4438C11.8192 20.4438 11.2073 20.5746 10.5527 20.8388C9.89721 21.1041 9.36912 21.2424 8.96536 21.2561C8.35131 21.2823 7.73926 21.0119 7.12832 20.4438C6.73839 20.1037 6.25067 19.5207 5.66639 18.6948C5.03951 17.8127 4.52413 16.7899 4.12037 15.6239C3.68796 14.3644 3.47119 13.1448 3.47119 11.964C3.47119 10.6115 3.76345 9.4449 4.34885 8.46733C4.80892 7.68211 5.42097 7.0627 6.18701 6.60799C6.95304 6.15328 7.78074 5.92156 8.6721 5.90673C9.15983 5.90673 9.79941 6.0576 10.5942 6.3541C11.3868 6.65159 11.8957 6.80246 12.1188 6.80246C12.2856 6.80246 12.851 6.62605 13.8093 6.27437C14.7157 5.94822 15.4806 5.81318 16.1072 5.86637C17.8052 6.00341 19.0809 6.67277 19.9293 7.87869C18.4107 8.79883 17.6595 10.0876 17.6744 11.7409C17.6881 13.0287 18.1553 14.1003 19.0734 14.9512C19.4895 15.3461 19.9542 15.6513 20.4712 15.8681C20.3591 16.1932 20.2407 16.5047 20.1149 16.8036ZM16.2206 1.4792C16.2206 2.48855 15.8518 3.43098 15.1168 4.30328C14.2298 5.34027 13.1569 5.9395 11.9935 5.84494C11.9787 5.72385 11.9701 5.59641 11.9701 5.46249C11.9701 4.49351 12.3919 3.45652 13.141 2.60863C13.515 2.17934 13.9906 1.82238 14.5674 1.53763C15.143 1.25713 15.6874 1.102 16.1994 1.07544C16.2143 1.21037 16.2206 1.34532 16.2206 1.47919V1.4792Z"
        fill="white"
      />
    </svg>
  );
}
